import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { MetricTitleText, MetricTitleIcon } from './DashboardCommonStyledComponents';

interface MetricPieceProps {
    id: string;
    titleText: string;
    titleIcon: string;
    metricValue: string | number;
    metricValueColor?: string;
    averageMetricValue?: string;
}

const MetricTitle = styled.div`
    display: flex;
    align-items: center;
`;

const AmountText = styled(Typography)`
    margin-top: 10px;
    font-family: Lato;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px;
    letter-spacing: 0.25px;
    text-align: left;
`;

const DetailText = styled(Typography)`
    margin-top: 8px;
    color: #56585f;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.10000000149011612px;
`;

const DashboardMetricPiece: React.FC<MetricPieceProps> = (props) => {
    const { titleText, titleIcon, metricValue, metricValueColor, averageMetricValue, id } = props;
    const { t } = useTranslation('dashboard');

    return (
        <div id={id}>
            <MetricTitle>
                <MetricTitleIcon path={titleIcon} />
                <MetricTitleText>{titleText}</MetricTitleText>
            </MetricTitle>
            <AmountText color={metricValueColor || 'black'} data-testid='amount'>{metricValue}</AmountText>
            <DetailText data-testid='detail'>{t('semester-average-var', { averageMetricValue })}</DetailText>
        </div>
    );
};

export default DashboardMetricPiece;
